export const configuration = {
  apiUrl: process.env.REACT_APP_API_URL ||  'https://plmapi.secretdemo.com',
}